import { machineTypeSchema } from "@packsize/schemas/machines";

export const SEAL_PRO_X_MACHINES_QUERY_KEY = ["machines", { machineType: machineTypeSchema.enum.SealProX }] as const;
